import './App.css';
import Navbar from './Components/Navbar/Navbar'
import Home from './Components/Home/Home'
import Service from './Components/Service/Service'
import Tool from './Components/Tool/Tool'
import Project from './Components/Project/Project'
import Contact from './Components/Contact/Contact'
import Footer from './Components/Footer/Footer'
import { SliderData } from './data/SliderData';
import About from './Components/About/About';
import Work from './Components/Work/Work';
import Aos from 'aos';
import { useEffect } from 'react';
import "aos/dist/aos.css";
import Address from './Components/Address/Address';

function App() {

  useEffect(() => {
    Aos.init();
  }, []);
  
  return (
    <div>
    <Navbar/>
    <section id='home'><Home/></section>
    <section id='about'><About/></section>
    <section id='service'><Service/></section>
    <Tool/>
    <section id='projects'><Project slides={SliderData}/></section>
    <Work/>
    <section id='contact'><Contact/></section>
    <Address/>
    <Footer/>
    </div>
  );
}

export default App;
